import { useState, useEffect } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const HP_RECENTLY_SEARCHED_TEST_NAME = 'HP_RecentlySearched_March2026';

const isHpRecentlySearchedTestVariant = (): boolean =>
    getAbTestV2(HP_RECENTLY_SEARCHED_TEST_NAME)?.variant === 'variant';

export const useIsHpRecentlySearchedTestVariant = (): boolean => {
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        setIsVariant(isHpRecentlySearchedTestVariant());
    }, []);

    return isVariant;
};

export const trackHpRecentlySearchedTest = (): void => {
    trackAbTestV2Variant(HP_RECENTLY_SEARCHED_TEST_NAME);
};
